var _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClydeCircle = function SvgClydeCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_2697)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9967 1.2207e-06C25.7144 0.00172528 16.8129 3.69033 10.2499 10.2545C3.6869 16.8187 -6.11953e-05 25.7209 -6.10352e-05 35.0032C-6.11953e-05 44.2856 3.6869 53.1878 10.2499 59.752C16.8129 66.3162 25.7144 70.0048 34.9967 70.0065C39.5934 70.0065 44.1452 69.1011 48.392 67.342C52.6387 65.5829 56.4974 63.0046 59.7477 59.7543C62.9981 56.5039 65.5765 52.6452 67.3355 48.3984C69.0946 44.1516 70 39.5999 70 35.0032C70 30.4066 69.0946 25.8549 67.3355 21.6081C65.5765 17.3613 62.9981 13.5026 59.7477 10.2522C56.4974 7.00187 52.6387 4.42354 48.392 2.66447C44.1452 0.905388 39.5934 1.2207e-06 34.9967 1.2207e-06ZM50.9706 41.8882C49.2607 48.071 44.2872 54.2407 36.0175 54.2407C33.5723 54.2614 31.1474 53.7961 28.8836 52.8717C26.6198 51.9473 24.5621 50.5822 22.8304 48.8559C21.0986 47.1296 19.7271 45.0763 18.7956 42.8154C17.8641 40.5546 17.3911 38.1311 17.4041 35.6859C17.4041 24.7181 24.7637 15.8373 35.5364 15.8373C44.8203 15.8373 50.3139 21.539 50.3139 25.9469C50.3359 26.3413 50.2728 26.7358 50.129 27.1037C49.9852 27.4716 49.7641 27.8043 49.4805 28.0793C49.1969 28.3543 48.8575 28.5651 48.4853 28.6974C48.1131 28.8298 47.7168 28.8806 47.3233 28.8465C42.4213 28.8465 42.8439 18.4443 34.5222 18.4443C29.2496 18.4443 24.5555 23.873 24.5555 30.8684C24.5555 41.7842 30.6343 47.8629 37.5582 47.8629C43.1884 47.8629 46.7057 44.2937 48.487 40.887C48.5512 40.7703 48.655 40.6804 48.7796 40.6334C48.9028 40.5845 49.04 40.5845 49.1632 40.6334L50.6585 41.238C50.7831 41.2859 50.8851 41.3787 50.9446 41.4981C50.9999 41.6207 51.0091 41.7593 50.9706 41.8882Z",
    fill: "url(#paint0_linear_343_2697)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_2697",
    x1: -0.0000610352,
    y1: 38.3491,
    x2: 70,
    y2: 38.3491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEED7A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489583,
    stopColor: "#FF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DF91FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_2697"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClydeCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clyde-circle.87d2e351.svg";
export { ForwardRef as ReactComponent };